import Banner from '../components/banner/Banner';

export function getBennerEveryNItems(i, n=10) {
    return (i > 0 && i % n === 0) ? (
        <li className="list-none">
            <Banner className='align-middle' />
        </li>
        ) : null;
}
